import {useState} from "react";

const useItem = (inputs) => {
	const [item, setItem] = useState({});
	const [errors, setErrors] = useState([]);

	const validate = () => {
		setDefaultValue();
		let errors = [];
		inputs.map((input) => {
			if (typeof input.required !== 'undefined' && input.required) {
				if (
					typeof item[input.name] === 'undefined' ||
					(
						typeof item[input.name] !== 'undefined' &&
						item[input.name] === null
					) ||
					(
						typeof item[input.name] !== 'undefined' &&
						item[input.name] === ""
					) ||
					(
						typeof item[input.name] === 'array' &&
						item[input.name].length === 0
					)
				) {
					errors.push(input.name);
				}
			}
		});
		if (errors.length > 0) {
			setErrors(errors);
			return false;
		}
		return true;
	}


	const updateItem = (key, value) => {
		let type = 'text';
		inputs.map((input) => {
			if (typeof input.name === key) {
				if (typeof input.type !== 'undefined') {
					type = input.type;
				}
			}
		});

		value = (value === null && type === 'text') ? '' : value;
		setItem({
			...item,
			[key]: value
		});
	}

	const getDefaultValue = () => {
		let values = {...item};
		inputs.map((input) => {
			if (
				typeof input.value !== 'undefined' && (
					typeof values[input.name] === 'undefined' ||
					(typeof values[input.name] !== 'undefined' && values[input.name] === null) ||
					(typeof values[input.name] !== 'undefined' && values[input.name].length && values[input.name].length === 0)
				)
			) {
				return values[input.name] = input.value;
			}
		});
		return values;
	}

	const setDefaultValue = () => {
		setItem(getDefaultValue());
	}

	return {
		updateItem,
		setItem,
		item,
		errors,
		validate,
		getDefaultValue
	};
};

export default useItem;
